var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient10, _radialGradient11, _radialGradient12, _radialGradient13, _radialGradient14, _radialGradient15, _radialGradient16, _radialGradient17, _radialGradient18, _radialGradient19, _radialGradient20, _radialGradient21, _radialGradient22, _radialGradient23, _radialGradient24, _radialGradient25, _radialGradient26, _radialGradient27, _radialGradient28, _radialGradient29, _radialGradient30, _radialGradient31, _radialGradient32, _radialGradient33, _radialGradient34, _radialGradient35, _radialGradient36, _radialGradient37, _radialGradient38, _radialGradient39, _radialGradient40, _radialGradient41, _linearGradient, _clipPath, _clipPath2, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSplit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 14,
    viewBox: "0 0 69 14",
    width: 69,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(33.46812963 -1.28267391 .90957572 23.73307654 24.7681 .793486)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03ba50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#01b64e"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(33.39828091 -1.27999694 .90768001 23.68361286 24.7637 .790524)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04bc50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#01b34d"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(33.32853211 -1.2773238 .9057843 23.63414917 24.7558 .79653)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#06bd51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#02b24c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#01b04b"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(33.25878332 -1.27465066 .9038886 23.58468548 24.746 .806713)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#08bf52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#04b44d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#01ad4a"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(33.1889346 -1.27197369 .90198906 23.53512187 24.7315 .816604)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ac053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#05b54e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#01aa49"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(33.11682208 -.95190615 .67518233 23.48959832 24.7169 .840812)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0bc253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#07b74e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#01a848"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(33.0470509 -.94990065 .67375722 23.4400188 24.7003 .846033)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0dc354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#08b84f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#01a546"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(32.97717976 -.94789229 .67206203 23.38104316 24.9441 .852592)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0fc555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0aba50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#01a245"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(33.23644306 -.9458872 .66400628 23.33175332 24.9219 .863893)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#11c656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#0cbb51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#019f44"
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(33.16597159 -.94388163 .66259811 23.28227336 24.9124 .875444)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#12c856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#0ebd51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#029e44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#019c43"
  }))), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(33.0931011 -.94180778 .66114443 23.23119404 24.9025 .89064)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#14c957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#0fbe52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#049f44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#019941"
  }))), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(33.02262963 -.93980221 .65973626 23.18171407 24.8886 .909904)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16cb58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#11c053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#06a145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#019640"
  }))), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(32.95215816 -.93779664 .65832525 23.13213415 24.8698 .930089)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cc59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#13c154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#07a246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#01933f"
  }))), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(32.87928767 -.93572279 .65687156 23.08105483 24.8546 .955119)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#19cd59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#15c254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#09a347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#01903e"
  }))), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(32.8088162 -.93371722 .6554634 23.03157486 24.8322 .981594)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1bcf5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#17c455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#0ba547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#018d3c"
  }))), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(32.73830807 -.62114254 .4361174 22.98626315 24.8065 .88437)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1dd05b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#18c556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0ca648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#018b3b"
  }))), _radialGradient17 || (_radialGradient17 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(32.66542119 -.61975966 .43514616 22.93507237 24.7795 .904536)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1ed25b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1ac756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0ea848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#01883a"
  }))), _radialGradient18 || (_radialGradient18 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(32.59493388 -.61842231 .43420717 22.88558127 24.7522 .924751)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20d35c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1bc857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0fa949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#018539"
  }))), _radialGradient19 || (_radialGradient19 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(32.52444656 -.61708495 .43326818 22.83609018 24.7216 .951694)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#22d55d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#1dca58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#11ab4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#018237"
  }))), _radialGradient20 || (_radialGradient20 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(32.45165966 -.61570397 .43229883 22.78499938 24.6855 .977197)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#24d65e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1fcb59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#13ac4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#017f36"
  }))), _radialGradient21 || (_radialGradient21 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(32.38117235 -.61436662 .43135984 22.73550828 24.6456 1.00832)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25d85e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#20cd59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#14ae4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#017d36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#007c35"
  }))), _radialGradient22 || (_radialGradient22 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(32.31068503 -.61302927 .43030513 22.67991829 25.3536 1.04284)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#27d95f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22ce5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#16af4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#027e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#007934"
  }))), _radialGradient23 || (_radialGradient23 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(32.55695509 -.61164229 .42512564 22.62890697 25.1113 1.07924)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#29db60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#24d05b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#18b14d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#048037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#007632"
  }))), _radialGradient24 || (_radialGradient24 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(32.48576766 -.6103049 .42419586 22.5794157 25.0846 1.11917)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2bdc61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#26d15c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1ab24e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#068138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#007331"
  }))), _radialGradient25 || (_radialGradient25 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "y",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(32.41228062 -.60892431 .42323414 22.52822473 25.0554 1.16351)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2cde61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#27d35c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#1bb44e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#088339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#007030"
  }))), _radialGradient26 || (_radialGradient26 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "z",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(32.34107319 -.30379413 .21118072 22.48170816 25.0215 .940123)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2edf62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#29d45d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#1db54f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#098439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#006e2f"
  }))), _radialGradient27 || (_radialGradient27 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "A",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(32.26987634 -.30312535 .2107167 22.43231034 24.9862 .974523)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#30e163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#2bd65e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1fb750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#0b8639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#006b2d"
  }))), _radialGradient28 || (_radialGradient28 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "B",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(32.19627958 -.30243459 .21023617 22.3811126 24.9515 1.01368)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#31e263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#2cd75e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#20b850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#0d873a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00682c"
  }))), _radialGradient29 || (_radialGradient29 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "C",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(32.12508272 -.30176524 .20977082 22.33161479 24.9122 1.05416)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33e364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#2ed85f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#22b951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#0e883b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00652b"
  }))), _radialGradient30 || (_radialGradient30 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "D",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(32.05148597 -.30107391 .20929084 22.28051704 24.8692 1.09782)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35e565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#30da60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#24bb52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#108a3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00622a"
  }))), _radialGradient31 || (_radialGradient31 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "E",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(31.98028911 -.30040513 .20882589 22.23101922 24.8287 1.14346)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#37e666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#32db61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#26bc53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#128b3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#005f28"
  }))), _radialGradient32 || (_radialGradient32 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "F",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(31.90679235 -.29971474 .20834496 22.17982148 24.7791 1.19331)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#38e866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#33dd61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#27be53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#148d3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#005c27"
  }))), _radialGradient33 || (_radialGradient33 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "G",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(31.8354955 -.29904502 .20788001 22.13032367 24.7289 1.24545)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3ae967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#35de62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#29bf54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#158e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#005926"
  }))), _radialGradient34 || (_radialGradient34 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "H",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(31.76439864 -.29837717 .20741599 22.08092585 24.6786 1.29985)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3ceb68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#37e063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#2bc155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#17903f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#005625"
  }))), _radialGradient35 || (_radialGradient35 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "I",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(31.69080188 -.29768585 .20693507 22.0297281 24.6243 1.35828)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3eec69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#39e164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#2dc256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#19913f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#005323"
  }))), _radialGradient36 || (_radialGradient36 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "J",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(31.6196 0 0 21.9793 24.5666 1.01157)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3fee69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#3ae364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2ec456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1a9340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#005122"
  }))), _radialGradient37 || (_radialGradient37 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "K",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(31.8553 0 0 21.9281 25.3121 1.06049)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41ef6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#3ce465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#30c557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1c9441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#015022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#004e21"
  }))), _radialGradient38 || (_radialGradient38 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "L",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(31.7858 0 0 21.8803 25.2655 1.11289)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#43f16b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#3ee666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#32c758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1e9642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#035223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#004b20"
  }))), _radialGradient39 || (_radialGradient39 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "M",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(31.7139 0 0 21.8308 25.2216 1.16896)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45f26c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#40e767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#34c859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#209742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#055323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00481e"
  }))), _radialGradient40 || (_radialGradient40 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "N",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(31.6396 0 0 21.7797 25.1779 1.22855)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#46f46c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#41e967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#35ca59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#229943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#065524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00451d"
  }))), _radialGradient41 || (_radialGradient41 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "O",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(31.5653 0 0 21.7285 25.1348 1.29194)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#48f56d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#43ea68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#37cb5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#239a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#085625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00421c"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse",
    x1: 25.6429,
    x2: 23.14,
    y1: 16.9153,
    y2: -1.8169
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ff8475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#e84e43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d6261f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#cc0e08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#c80500"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "Q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.582 0h14.6118v14h-14.6118z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "R"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 14,
    rx: 7,
    width: 14.6118
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#033d23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35.99 12.4018c-1.3508 0-2.4166-.4701-3.1975-1.4105-.7809-.9504-1.1714-2.2851-1.1714-4.004 0-1.67845.3852-3.00301 1.1555-3.97368.781-.97067 1.8996-1.456 3.3559-1.456.5065 0 .9603.07078 1.3613.21233.401.13145.7282.28311.9815.455v1.47118c-.285-.17189-.6227-.33367-1.0131-.48534-.3905-.15167-.8021-.2275-1.2347-.2275-.9287 0-1.6041.32861-2.0262.98584-.4221.65722-.6332 1.66328-.6332 3.01817 0 1.31445.2111 2.3104.6332 2.98785.4221.66735 1.0659 1.00105 1.9312 1.00105.5065 0 .9445-.0708 1.3138-.2124.3694-.1516.7124-.3387 1.029-.5611v1.4711c-.2428.1618-.5699.3236-.9815.4854-.4115.1617-.9128.2426-1.5038.2426z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.6669 4.6213h6.2052v7.6289h-1.8837v-6.20323h-2.4378v6.20323h-1.8837z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.8248 10.688s.0369.0253.1108.0758c.0739.0405.1794.0607.3166.0607.306 0 .5066-.1517.6015-.455.095-.3034.1583-.85946.19-1.66836l.1583-4.07984h5.3978v7.6289h-1.8837v-6.20323h-1.9153l-.1109 2.73001c-.0422 1.26392-.2057 2.18402-.4907 2.76032-.2849.5764-.8284.8645-1.6304.8645-.2216 0-.401-.0253-.5382-.0758-.1372-.0506-.2058-.0758-.2058-.0758z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.1872 4.6213h1.8362v4.71685l2.9127-4.71685h1.6304v7.6289h-1.8362v-4.71689l-2.9126 4.71689h-1.6305z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.9894 6.04697h-2.2161v6.20323h-1.8837v-6.20323h-2.2161v-1.42567h6.3159z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.9149 7.03308 5.1325 5.03572-.1047.0914-.0442.0401c-1.4372 1.2283-3.3203 1.8666-5.2439 1.7776-1.9235-.0891-3.7337-.8984-5.0405-2.2537s-2.0059-3.14818-1.9465-4.99249c.0593-1.8443.8722-3.5925 2.2637-4.86812 1.4306-1.254412 3.3195-1.9182685 5.2574-1.8477536 1.9379.0705148 3.7687.8697226 5.096 2.2244936z",
    fill: "#01b94f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9352 1.86225c1.4304-1.253319 3.3186-1.9163032 5.2555-1.8453737 1.937.0709295 3.7668.8700627 5.0932 2.2243337 0 0-4.2693 3.82975-4.3554 3.89662 0 0-.9562.8627-.9492.87608.0069.01337 5.058 5.03569 5.058 5.03569l-.1024.0937-.0442.0401c-3.0153 2.5413-7.6359 2.4254-10.365-.4013-1.3106-1.3711-2.0029-3.18281-1.9262-5.04066.0767-1.85784.9162-3.61147 2.3357-4.87919z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9366 1.85741c1.4316-1.251659 3.3198-1.9131358 5.2564-1.841385s3.7659.870962 5.0923 2.224805c0 0-4.1553 3.74504-4.3252 3.87657 0 0-.9306.85155-.9143.8783.0349.08025 4.9836 5.0313 4.9836 5.0313l-.1024.0936-.0442.0401c-3.0083 2.5368-7.6313 2.412-10.351-.4057-1.3087-1.3674-2.0004-3.17483-1.9246-5.02865s.9131-3.60385 2.3294-4.86894z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9412 1.85517c1.4317-1.250018 3.3191-1.9102605 5.2545-1.8381021 1.9355.0721584 3.7636.8709251 5.0896 2.2237521 0 0-4.0367 3.6581-4.2972 3.8565 0 0-.8981.83817-.8818.8783.0535.12038 4.9137 5.03128 4.9137 5.03128l-.1046.0936-.0443.0379c-2.9989 2.5302-7.6196 2.4009-10.3347-.4101-1.3065-1.3636-1.9972-3.16691-1.9214-5.01653.0759-1.84962.9121-3.59545 2.3262-4.8566z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9463 1.85305c1.4318-1.249058 3.3189-1.9084886 5.2538-1.8359178 1.9349.0725709 3.7624.8713208 5.088 2.2237978 0 0-3.9204 3.56671-4.267 3.83644 0 0-.8702.82703-.8469.88053.0698.1605 4.8393 5.0291 4.8393 5.0291l-.1024.0914s-.0442.0378-.0442.0401c-2.992 2.5212-7.6126 2.383-10.3208-.4169-1.3044-1.3594-1.9945-3.1581-1.9195-5.00333s.9089-3.58709 2.3197-4.84522z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.949 1.84881c1.4321-1.247136 3.3185-1.9049433 5.2523-1.8315478s3.76.8721118 5.0847 2.2238878c0 0-3.8016 3.48645-4.2367 3.81637 0 0-.8422.81365-.8143.88053.0884.20062 4.7695 5.02685 4.7672 5.02905l-.1024.0914-.0442.0401c-2.985 2.5101-7.6033 2.3696-10.3045-.4235-1.3022-1.3559-1.9913-3.15058-1.9167-4.9918.0745-1.84121.9067-3.5793 2.3146-4.83449z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9514 1.84669c1.4324-1.246174 3.3184-1.90317 5.2517-1.8293622 1.9332.0738078 3.7587.8725082 5.083 2.2239322 0 0-3.6853 3.40174-4.2064 3.78962 0 0-.8144.80028-.7795.88053.1047.24075 4.6951 5.02459 4.6951 5.02459l-.1023.1137-.0443.0379c-2.9803 2.4922-7.5963 2.3473-10.2928-.4392-1.2998-1.352-1.9879-3.14223-1.9138-4.97906.0742-1.83682.9044-3.57078 2.3093-4.82265z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9587 1.84359c1.4325-1.245208 3.3183-1.9013927 5.251-1.8271727 1.9326.0742199 3.7575.8729037 5.0814 2.2239727 0 0-3.569 3.31703-4.1762 3.78962 0 0-.7887.7869-.7492.88053.1326.26973 4.6253 5.01346 4.623 5.01346l-.1024.0914-.0442.0401c-2.9711 2.4945-7.587 2.3429-10.2766-.4347-1.298-1.3479-1.9854-3.13381-1.9117-4.96643s.9025-3.56254 2.3049-4.81078z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9591 1.83948c1.433-1.243973 3.3186-1.8989579 5.2507-1.8239086 1.9321.0750492 3.7562.8741286 5.0794 2.2251586 0 0-3.4527 3.23009-4.146 3.75841 0 0-.7608.77576-.7142.89168.1396.321 4.5508 5.02238 4.5485 5.02238-.0024 0-.0954.0869-.1024.0914l-.0442.0379c-2.9641 2.4788-7.5801 2.3228-10.2626-.4392-1.2992-1.3446-1.9879-3.12847-1.9146-4.95944s.9026-3.5591 2.3054-4.80438z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9661 1.83725c1.4331-1.242334 3.3178-1.8960885 5.2488-1.8206322s3.7539.8740942 5.0766 2.2241122c0 0-3.334 3.14539-4.1157 3.73835 0 0-.7329.76238-.6794.89167.1559.36113 4.4764 5.02015 4.4764 5.02235l-.1024.0914-.0442.0379c-2.9571 2.4789-7.5731 2.3161-10.237-.4458-1.2977-1.3396-1.987-3.11808-1.9163-4.94447.0707-1.82638.8955-3.55109 2.2932-4.79488z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9671 1.83513c1.4332-1.241368 3.3176-1.8943129 5.2481-1.8184445 1.9304.0758683 3.7527.8744915 5.075 2.2241645 0 0-3.2177 3.05844-4.0948 3.71828 0 0-.698.75124-.6468.89168.1815.39456 4.4159 5.01119 4.4135 5.01349l-.1023.0891s-.0396.0357-.0442.0401c-2.9502 2.47-7.5638 2.3006-10.2371-.4458-.6401-.6622-1.1378-1.4386-1.4647-2.28512-.327-.84647-.4766-1.74636-.4406-2.64826.0361-.90191.2573-1.78818.6508-2.60819.3936-.82002.9519-1.55772 1.6431-2.171z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9701 1.83042c1.4336-1.239452 3.3173-1.8907785 5.2466-1.8140862s3.7503.8752862 5.0718 2.2242562c0 0-3.099 2.97374-4.0552 3.69823 0 0-.6771.74009-.6119.89167.1907.44584 4.3321 5.01791 4.3321 5.02011l-.1024.0892-.0442.0379c-2.9455 2.4566-7.5568 2.2827-10.2207-.4615-1.2894-1.3333-1.9733-3.10266-1.9014-4.91903.072-1.81637.894-3.53098 2.2853-4.76675z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9736 1.82851c1.4341-1.238631 3.3179-1.8892102 5.2471-1.8121081 1.9291.0771021 3.7498.8757411 5.0713 2.2245081 0 0-2.985 2.89795-4.0273 3.68039 0 0-.6468.72449-.5793.89168.2094.47482 4.2623 5.01342 4.26 5.01342l-.1024.0914-.0442.0379c-2.9362 2.4521-7.5475 2.2738-10.2045-.4614-.6381-.6582-1.1345-1.4305-1.4608-2.27273-.3263-.8422-.4762-1.73778-.441-2.63551.0353-.89773.2549-1.77999.6463-2.59634s.9469-1.55075 1.6348-2.16121z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9768 1.8258c1.4342-1.236994 3.3172-1.8863465 5.2452-1.8088377s3.7476.8757087 5.0686 2.2234677c0 0-2.8663 2.80209-3.9971 3.66033 0 0-.6188.71334-.5444.89168.2327.52163 4.1879 5.01346 4.1879 5.01566l-.1024.0914s-.0395.0334-.0419.0379c-2.9315 2.4521-7.5405 2.2582-10.1928-.4681-2.6523-2.72632-2.5197-7.12674.3769-9.6435z",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9814 1.82169c1.4347-1.23575 3.3175-1.8839045 5.245-1.8055671 1.9274.0783373 3.7462.8769341 5.0665 2.2246571 0 0-2.75 2.71292-3.9552 3.63581 0 0-.5933.69996-.5119.89167.2443.56176 4.1135 5.01124 4.1135 5.01344l-.1024.0892-.0442.0379c-2.9339 2.4365-7.5521 2.247-10.1859-.4726-2.6337-2.71963-2.515-7.10444.3746-9.61451z",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9858 1.81948c1.4347-1.234121 3.3167-1.8810509 5.243-1.8023071s3.744.8769041 5.0638 2.2236171c0 0-2.6314 2.63045-3.9343 3.62021 0 0-.5654.68882-.4793.89167.2629.59965 4.039 5.00673 4.039 5.00903l-.1024.0891-.0442.0379c-2.9129 2.4276-7.5312 2.2314-10.1602-.4793-2.6291-2.71065-2.5104-7.08877.3746-9.58992z",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9867 1.81688c1.4349-1.233157 3.3165-1.8792797 5.2423-1.8001243s3.7428.8773023 5.0622 2.2236743c0 0-2.5151 2.54573-3.904 3.60014 0 0-.5375.66876-.4444.89167.2792.63532 3.9738 5.00676 3.9738 5.00896l-.1.0892-.0442.0379c-2.9176 2.4097-7.5336 2.218-10.1556-.4882-2.6221-2.70623-2.5104-7.06875.3699-9.56322z",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9911 1.81249c1.4359-1.230853 3.3171-1.8750705 5.242-1.7951015s3.7409.8777865 5.0602 2.2231015c0 0-2.3987 2.45211-3.8668 3.58008 0 0-.5095.66876-.4118.89167.2885.68214 3.9017 5.00456 3.8877 5.00676l-.1024.0892c-.0136.0138-.0284.0264-.0442.0379-2.9012 2.412-7.5172 2.2091-10.1323-.4905-2.6151-2.6995-2.5034-7.05534.3676-9.54311z",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9928 1.8109c1.4376-1.229002 3.32-1.8704018 5.2447-1.787089 1.9247.083313 3.739.884728 5.0551 2.232929 0 0-2.2823 2.35848-3.8458 3.55109 0 0-.4816.65093-.3769.89168.3141.72449 3.8249 5.00679 3.8226 5.00899-.0024.0022-.0861.078-.1024.0892l-.0419.0379c-2.8966 2.3941-7.5102 2.1801-10.1207-.5061-2.6104-2.68614-2.508-7.03974.3653-9.5186z",
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9981 1.80815c1.4371-1.228188 3.3185-1.8691091 5.2423-1.7857996 1.9238.0833096 3.7372.8842416 5.0529 2.2316396 0 0-2.1638 2.28046-3.8157 3.53549 0 0-.4537.63755-.3443.89167.3327.76462 3.7551 5.00455 3.7505 5.00675l-.1001.0892-.0442.0379c-2.8896 2.3852-7.5009 2.1667-10.1044-.5127-2.6035-2.67952-2.5034-7.02421.363-9.49415z",
    fill: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0003 1.79495c1.4373-1.22697 3.3181-1.8671208 5.2411-1.7838245 1.9231.0832963 3.7359.8834415 5.0518 2.2296645 0 0-2.0474 2.19575-3.7831 3.51543 0 0-.4281.62418-.3117.89168.349.80474 3.6806 5.0045 3.6783 5.0068l-.1023.0891-.0443.0357c-2.8803 2.3919-7.4916 2.1668-10.0904-.5016-2.5988-2.66831-2.4988-7.01077.3606-9.48295z",
    fill: "url(#t)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0033 1.79513c1.4368-1.226156 3.3167-1.8658284 5.2388-1.7825355 1.9221.083293 3.7341.8829565 5.0495 2.2283755-1.1567 1.25662-2.4113 2.42734-3.7529 3.50206 0 0-.4001.61303-.2768.89168.3653.84486 3.6062 5.00009 3.6039 5.00449l-.1001.087-.0442.0379c-2.8756 2.3785-7.4846 2.1489-10.0765-.5127-2.5918-2.66169-2.4987-7.00416.3583-9.45627z",
    fill: "url(#u)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0095 1.79474c1.437-1.225622 3.3168-1.8649401 5.2387-1.7816549s3.7339.8825849 5.0495 2.2274949c-1.1405 1.25319-2.3854 2.41545-3.7225 3.4753 0 0-.37.59966-.2327.89168.3839.89168 3.5364 5.00004 3.5318 5.00234l-.1001.0891-.0442.0379c-2.8803 2.3741-7.4893 2.14-10.0765-.5127-2.5872-2.65273-2.4941-6.97735.356-9.42946z",
    fill: "url(#v)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0125 1.79512c1.437-1.22374 3.3157-1.8618747 5.2363-1.7786082 1.9206.0832666 3.7315.8813602 5.0473 2.2244482-1.1226 1.25408-2.359 2.41036-3.6946 3.45524 0 0-.3421.58851-.2094.89168.4001.93403 3.4619 5.01572 3.4596 5.01572s-.0814.0735-.1024.0891l-.0418.0357c-2.8618 2.354-7.4684 2.1043-10.0486-.5306-2.5802-2.63486-2.4941-6.95057.3536-9.40268z",
    fill: "url(#w)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0165 1.79501c1.4369-1.22306 3.3151-1.8607794 5.2352-1.7775183 1.92.0832613 3.7304.8809323 5.0461 2.2233583-1.1044 1.25637-2.3315 2.40888-3.6644 3.44187 0 0-.3141.57513-.1768.89168.4211.96524 3.3922 4.9978 3.3875 5.0001l-.1.0869-.0442.0379c-2.8548 2.3563-7.4591 2.1088-10.0323-.5283-2.5733-2.63714-2.4918-6.94617.3489-9.37599z",
    fill: "url(#x)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0181 1.7954c1.4367-1.222392 3.3144-1.8596958 5.2339-1.7764402 1.9195.0832552 3.7294.8805052 5.045 2.2222802-1.0855 1.25857-2.3042 2.40603-3.6365 3.42403 0 0-.2861.56176-.1419.89168.4374 1.00536 3.3177 4.99335 3.3154 4.99785l-.1024.0869-.0442.0379c-2.8431 2.3451-7.4474 2.0932-10.0067-.535-2.5592-2.62819-2.4964-6.93053.3374-9.3492z",
    fill: "url(#y)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0197 1.7952c1.4365-1.22105 3.3132-1.8575251 5.2315-1.7742806 1.9184.0832446 3.7273.8796516 5.0428 2.2201106-1.0652 1.259-2.2732 2.40067-3.6016 3.40397 0 0-.2606.55061-.1094.89168.4654 1.04549 3.2573 4.99342 3.241 4.99782l-.1.087-.0443.0356c-2.8407 2.3384-7.4428 2.0799-10.002-.5394-2.5593-2.61933-2.4895-6.91498.342-9.3225z",
    fill: "url(#z)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0223 1.79471c1.4367-1.219841 3.3127-1.8555516 5.2303-1.7723202 1.9177.0832312 3.726.8788582 5.0417 2.2181602-1.0438 1.26173-2.243 2.39794-3.5714 3.38391 0 0-.2326.53723-.0767.89167.4653 1.08562 3.1734 4.99117 3.1688 4.99337-.0047.0023-.0768.0691-.1001.087l-.0442.0379c-2.8314 2.3317-7.4335 2.0686-9.9927-.544-2.5593-2.61258-2.4802-6.89931.3443-9.29569z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0279 1.7817c1.4382-1.217483 3.3148-1.8504494 5.2319-1.7647252s3.724.8834002 5.0377 2.2239352c0 0-1.1122 1.51585-3.5434 3.36385 0 0-.2048.52609-.0419.89167.4886 1.1146 3.099 4.99117 3.0967 4.99337l-.1024.087-.0419.0378c-2.8268 2.3229-7.4265 2.0531-9.9857-.5506-2.5593-2.60365-2.4732-6.88369.349-9.2823z",
    fill: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0312 1.77724c1.4389-1.215713 3.3152-1.847141 5.2316-1.7605975s3.7224.8842645 5.0356 2.2242675c0 0-.9934 1.42223-3.5131 3.34379-.0939.29042-.0939.60126 0 .89168.5072 1.16586 3.0246 4.98672 3.0246 4.99112l-.1001.087-.0442.0356c-2.8291 2.3184-7.4265 2.0442-9.9695-.5506-2.5429-2.59475-2.4801-6.86811.3351-9.26226z",
    fill: "url(#C)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0355 1.77485c1.4385-1.215157 3.3142-1.8460706 5.2298-1.7591064 1.9156.0869644 3.7207.8849754 5.0328 2.2250064 0 0-.8771 1.33751-3.4899 3.3148-.0822.29328-.0733.60317.0256.89168.5235 1.2216 2.9618 5.00227 2.9571 5.00677l-.1.0869-.0419.0357c-2.8129 2.3027-7.4102 2.033-9.9485-.564-2.5384-2.597-2.4755-6.85252.335-9.23775z",
    fill: "url(#D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0401 1.77276c1.4387-1.214199 3.3141-1.8443117 5.2291-1.7569368 1.9151.0873748 3.7195.8853778 5.0312 2.2250668 0 0-.7585 1.25949-3.4527 3.30589-.0648.29682-.0447.6049.0582.89167.5421 1.24612 2.885 4.98445 2.8803 4.98895l-.1.0847-.0442.0379c-2.8059 2.3005-7.4009 2.0129-9.9323-.564-2.5709-2.61261-2.4755-6.83692.3304-9.21324z",
    fill: "url(#E)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0426 1.76871c1.4392-1.211772 3.3138-1.8399352 5.2276-1.7517473 1.9138.0881883 3.7168.8858173 5.028 2.2243273 0 0-.6421 1.16587-3.4224 3.27691-.048.29999-.016.60673.0931.89168.5584 1.28624 2.8105 4.98442 2.8059 4.98672l-.1001.0869-.0442.0357c-2.7919 2.2849-7.3869 2.0062-9.9183-.5752-2.5313-2.58135-2.4708-6.80567.3304-9.17529z",
    fill: "url(#F)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0446 1.76585c1.4398-1.210953 3.3144-1.8383802 5.228-1.7497841s3.7164.8862801 5.0276 2.2246041c0 0-.5258 1.07893-3.3922 3.25685-.0314.30254.0117.60793.1257.89167.5746 1.3442 2.736 4.99111 2.7314 5.00231l-.1001.0869-.0418.0357c-2.792 2.276-7.3847 1.9795-9.9044-.5796-2.5592-2.59923-2.4685-6.80794.3258-9.16865z",
    fill: "url(#G)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0488 1.76357c1.4396-1.209866 3.3135-1.8364305 5.2262-1.7474217 1.9127.0890087 3.7144.8866257 5.0248 2.2244717 0 0-.4095 1.00313-3.3619 3.2457-.0132.30457.0407.60838.1582.89167.5933 1.37541 2.6663 4.98891 2.6616 5.00231l-.1.0847-.0442.0357c-2.785 2.2604-7.3754 1.9594-9.8904-.5952-2.5523-2.59034-2.4662-6.79013.3257-9.14193z",
    fill: "url(#H)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0538 1.75913c1.4402-1.208104 3.3139-1.8331343 5.2258-1.7433072 1.912.0898272 3.7128.8874912 5.0228 2.2248072 0 0-.2908.9162-3.3317 3.22564.005.30985.0705.61606.1931.90282.6119 1.40662 2.5919 4.97781 2.5872 4.98221l-.1.0847-.0419.0357c-2.778 2.2604-7.3683 1.9528-9.8764-.593-2.5476-2.58136-2.4639-6.77446.3211-9.11957z",
    fill: "url(#I)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0577 1.75706c1.4411-1.203356 3.3131-1.824397 5.2222-1.7325191 1.9092.0918781 3.7068.8895151 5.0148 2.2251691 0 0-.1745.82257-3.3014 3.19665.027.31088.1055.61564.2326.90283.6306 1.44897 2.5221 4.97781 2.5174 4.98221l-.1.0847c-.0158.0107-.0306.0226-.0442.0357-2.771 2.2515-7.3591 1.9349-9.8602-.5997-2.5429-2.57467-2.4638-6.75662.3188-9.09504z",
    fill: "url(#J)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.059 1.75497c1.4412-1.203606 3.3135-1.8246067 5.2228-1.7323044 1.9094.0923024 3.7069.8907084 5.0143 2.2271844 0 0-.0558.73786-3.2712 3.17659.0457.31121.1333.61543.2606.90506.6514 1.48241 2.4522 4.9733 2.4476 4.9778l-.1001.0847c-.0139 0-.0302.0267-.0442.0357-2.764 2.2447-7.3497 1.926-9.8462-.6042-2.536-2.56576-2.4592-6.74103.3164-9.07053z",
    fill: "url(#K)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.063 1.75026c1.4423-1.201985 3.3146-1.8215204 5.2237-1.7284028 1.909.0931178 3.706.8916368 5.0134 2.2277428 0 0 .0605.65984-3.241 3.15876.0676.3097.1674.61215.2978.90282.6631 1.52923 2.3755 4.97332 2.3685 4.97782-.007.0044-.0675.0602-.1.0847l-.0419.0356c-2.757 2.2404-7.3451 1.9105-9.8345-.6108-2.5337-2.55907-2.4569-6.72542.314-9.04824z",
    fill: "url(#L)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0652 1.74815c1.4426-1.201959 3.3154-1.8210665 5.2246-1.7271083 1.9093.0939583 3.706.8936593 5.0125 2.2308983 0 0 .1768.56399-3.2107 3.13648.0869.30842.1958.61081.3257.90505.6817 1.56043 2.3033 4.97113 2.2987 4.97553l-.1001.0847-.0442.0357c-2.7477 2.2203-7.3334 1.8948-9.8182-.6153-2.5267-2.55461-2.4546-6.71205.3117-9.02595z",
    fill: "url(#M)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.0723 1.74568c1.4428-1.201675 3.3158-1.8203948 5.225-1.7260206 1.9093.0943746 3.7059.8944876 5.012 2.2320506 0 0 .2885.47704-3.1828 3.10971 0 0 .128.37451.3606.90506.698 1.60947 2.2289 4.97112 2.2243 4.97552l-.1001.0847-.0419.0335c-2.7454 2.2269-7.3288 1.8903-9.8066-.6131-2.522-2.54792-2.4522-6.69644.3095-9.00142z",
    fill: "url(#N)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.7005 11.2289c-2.7175 2.3407-7.4149 2.0308-9.9323-.5172-2.5173-2.54792-2.4499-6.68753.3072-8.97913 1.4436-1.200592 3.3169-1.8181931 5.2259-1.72299541 1.9091.09519741 3.7053.89578041 5.0111 2.23347541 0 0 .4118.39234-3.1502 3.09634-.007.00892 2.5476 5.88281 2.5383 5.88951z",
    fill: "url(#O)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.0473 5.42383c-1.1145.87607-2.4848 1.90819-4.0785 3.06514 1.1839 1.22673 2.5608 2.26843 4.0808 3.08743 1.3052.6688 2.3266.7936 2.8268.37.5002-.4235.4397-1.3999-.1419-2.67499-.6887-1.40473-1.5946-2.70185-2.6872-3.84758z",
    fill: "url(#P)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.1488 5.33691-.5584.44584c1.0224 1.07685 1.8723 2.29312 2.522 3.60906.5701 1.25729.5561 1.88809.3723 2.04639s-.9772.1984-2.2452-.4458c-1.4046-.7633-2.675-1.73369-3.7644-2.87569l-.6235.44584.1465.13598c2.6407 2.61487 5.4978 4.10397 6.7542 3.56227.0372-.0179.0744-.0357.1093-.0558h.014c.0486-.0288.0945-.0617.1372-.098.0453-.0393.0866-.0826.1233-.1293.8213-1.0321-.4257-3.81194-2.9105-6.53601z",
    fill: "#84eeb1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#R)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h14.6118v14h-14.6118z",
    fill: "#fc3f1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.33669 11.2071h1.52635v-8.39997h-2.22014c-2.23277 0-3.40591 1.09986-3.40591 2.71942 0 1.29324.64334 2.05468 1.79125 2.84029l-1.99308 2.84026h1.65249l2.22015-3.17868-.76948-.49554c-.93347-.60431-1.3876-1.07568-1.3876-2.09093 0-.89439.65596-1.49871 1.90479-1.49871h.68118z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplit);
export default __webpack_public_path__ + "static/media/split.643ffdfeffa0ee5d4f6f91694548fee5.svg";
export { ForwardRef as ReactComponent };